export { default as CouponCodeWrapper } from './couponCodeWrapper'



// WEBPACK FOOTER //
// ./src/components/couponCode/index.js